<template>
  <div class="card card-development-objective">
    <div class="card-header">
      <div class="row no-gutters">
        <div class="col d-flex align-items-center">
          <textarea
            class="form-control auto-height"
            placeholder="Development objective...."
            rows="1"
            name="description"
            :data-vv-scope="`objectives.${objectiveIndex}`"
            v-model.lazy="stateDescription"
            v-validate.disable="'required'"
            v-auto-height
          ></textarea>
        </div>
        <div class="col-auto d-flex align-items-center">
          <button type="button" class="btn btn-link text-danger btn-delete-development-objective" @click="confirmBeforeDeleting">
            <font-awesome :icon="['far', 'trash-alt']" fixed-width/>

            <span class="sr-only">Delete Development Objective</span>
          </button>
        </div>
      </div><!-- /.row -->
    </div>

    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col">
            <p>Method.</p>
          </div>
        </div><!-- /.row -->
      </li>

      <li>
        <div class="row">
          <div class="col-12 pt-3 pb-3 methods" :class="[errorClass('method', `objectives.${objectiveIndex}.method`)]">
            <p class="text-muted mb-2">Select all that apply:</p>
            <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                :id="`checkEducation${objectiveIndex}`"
                v-model="stateEducation"
                name="education"
                v-validate="'required:false'"
              >
              <label class="form-check-label" :for="`checkEducation${objectiveIndex}`">Education</label>
            </div>

            <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                :data-vv-scope="`objectives.${objectiveIndex}`"
                :id="`checkExperience${objectiveIndex}`"
                v-model="stateExperience"
                name="experience"
                v-validate="'required:false'"
              >
              <label
                class="form-check-label"
                :for="`checkExperience${objectiveIndex}`"
              >Experience</label>
            </div>

            <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                :data-vv-scope="`objectives.${objectiveIndex}`"
                :id="`checkExposure${objectiveIndex}`"
                v-model="stateExposure"
                name="exposure"
                v-validate="'required:false'"
              >
              <label class="form-check-label" :for="`checkExposure${objectiveIndex}`">Exposure</label>
            </div>
          </div>
        </div><!-- /.row -->
      </li>
    </ul>

    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p>
              Action Steps
              <span class="minor">Minimum of 2.</span>
            </p>
          </div>

          <div class="col-6 col-lg-2">
            <p>Start Date</p>
          </div>

          <div class="col-6 col-lg-2">
            <p>End Date</p>
          </div>
        </div><!-- /.row -->
      </li>

      <placements-start-component-development-item-action
        v-for="(action, actionIndex) in actions"
        :key="`objective-${objectiveIndex}-action-${actionIndex}`"
        :objective-index="objectiveIndex"
        :action-index="actionIndex"
        :action="action"
        :is-last-action="actionIndex === actions.length - 1"
      />
    </ul><!-- /.list-data -->
  </div><!-- /.card -->
</template>

<script>
import { alert } from 'utils'
import { placementDevelopmentObjectiveMethods } from 'vx/helpers'
import PlacementsStartComponentDevelopmentItemAction from './PlacementsStartComponentDevelopmentItemAction'

export default {
  inject: ['$validator'],

  props: {
    objectiveIndex: {
      required: true,
      type: Number
    },
    objective: {
      required: true,
      type: Object
    }
  },

  components: {
    PlacementsStartComponentDevelopmentItemAction
  },

  computed: {
    stateDescription: {
      get () {
        return this.objective.description
      },

      set (value) {
        this.setObjectiveProperty({
          objectiveIndex: this.objectiveIndex, property: 'description', value
        })
      }
    },

    stateEducation: {
      get () {
        return this.objective.education
      },

      set (value) {
        this.setObjectiveProperty({
          objectiveIndex: this.objectiveIndex, property: 'education', value
        })
      }
    },

    stateExperience: {
      get () {
        return this.objective.experience
      },

      set (value) {
        this.setObjectiveProperty({
          objectiveIndex: this.objectiveIndex, property: 'experience', value
        })
      }
    },

    stateExposure: {
      get () {
        return this.objective.exposure
      },

      set (value) {
        this.setObjectiveProperty({
          objectiveIndex: this.objectiveIndex, property: 'exposure', value
        })
      }
    },

    actions () {
      return this.objective.actions
    }
  },

  watch: {
    actions: {
      handler () {
        if (this.actions.length === 0) {
          this.addBlankAction(this.objectiveIndex)
        } else {
          let action = this.actions[this.actions.length - 1]

          if (
            (action.description !== null && action.description !== '') ||
            (action.start_date !== null && action.start_date !== '') ||
            (action.end_date !== null && action.end_date !== '')
          ) {
            this.addBlankAction(this.objectiveIndex)
          }
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...placementDevelopmentObjectiveMethods,

    async confirmBeforeDeleting () {
      if (
        !await alert.confirm({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete this development objective and any action steps.'
        })
      ) {
        return
      }

      this.deleteObjective(this.objectiveIndex)
    }
  }
}
</script>

<style>
  .methods.is-invalid {
    background-color: rgba(184, 18, 55, 0.15) !important
  }
</style>
